import List from '@mui/material/List';
import { NavItemType } from '../type';
import { useSidebar } from '../context';
import SidebarNavItem from './SidebarNavItem/SidebarNavItem';
import SidebarNavItemCollapse from './SidebarNavItemCollapse';
import Typography from '@mui/material/Typography';

interface NavGroupProps {
  item: NavItemType;
}

const SidebarNavGroup = ({ item }: NavGroupProps) => {
  const { isSideBarOpen } = useSidebar();
  const items = item.children?.map((menu) => {
    switch (menu?.type) {
      case 'collapse':
        return <SidebarNavItemCollapse key={menu.id} menu={menu} level={1} parentId={item.id!} />;
      case 'item':
        return <SidebarNavItem key={menu.id} item={menu} level={1} isSideBarOpen={isSideBarOpen} />;
      default:
        return (
          <Typography key={menu?.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <List disablePadding={!isSideBarOpen}>
        {item.title && (
          <Typography variant="caption" display="block" gutterBottom>
            {item.title}
            {item.caption && (
              <Typography variant="caption" display="block" gutterBottom>
                {item.caption}
              </Typography>
            )}
          </Typography>
        )}

        {items}
      </List>
    </>
  );
};

export default SidebarNavGroup;
